<template>
  <b-form-group class="list-date">
    <b-form-group>
      <b-form-input 
        :id="dateId" 
        v-model="fecha" 
        type="date">
      </b-form-input>
    </b-form-group>
    <b-input-group-append 
        class="filter-search-icons">
      <b-input-group-text>
        <i class="fa fa-check" @click="actualizar"></i>
      </b-input-group-text>
      <b-input-group-text>
        <i class="fa fa-times" @click="cancelar"></i>
      </b-input-group-text>
    </b-input-group-append>
  </b-form-group>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    dateId: {
      type: String,
      default: ''
    },
    currentFecha: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      fecha: '',
      updating: false
    }
  },
  created() {
      this.updating = true;
      this.fecha = moment(this.currentFecha).format('YYYY-MM-DD');
      this.updating = false;
  },
  computed: {
  },     
  methods: {
    validate() {
      this.$emit('validate');
    },
    actualizar() {
      this.$emit('updated', this.fecha);
    },
    cancelar() {
      this.$emit('close');
    }
  },
  watch: {
    'fecha' : function(newVal, oldVal) {
      this.updating = true;
      this.fecha = newVal;
      this.updating = false;
    },
    // 'propiedad' : function(newVal, oldVal) {
    //   if (newVal != oldVal && !this.updating) {
    //     this.$emit('updated', this.propiedad);
    //   }
    // },
  }    
}
</script>

<style>
  .list-date {
    position: relative;
    top: -2px;
    margin-bottom: 0;
  }
  .list-date div {
    display: flex;
  }
  .list-date .form-group {
    margin-bottom: 0;
  }
  .list-date input {
    font-size: 0.8em;
    padding: 0 4px;
  }
  .list-date .input-group-text {
    background-color: transparent;
    border: none;
    font-size: 0.8em;
    padding-left: 6px;
    padding-right: 6px;    
  }
  .list-date .input-group-text:first-of-type {
    color: green;
    margin-left: 3px;
  }
  .list-date .input-group-text:last-of-type {
    color: red;
  }
</style>
